module.exports = __webpack_public_path__ + "static/media/image-placeholder.34d4b154.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image-placeholder.svg
// module id = 74
// module chunks = 0